/* Marinelie — das Tausend-Punkte-Feld.
   Im Feld steht ein violetter Punkt: wir. Ringsherum leuchten
   nacheinander die anderen Haeuser auf — grau, mit Namen, immer nur
   eines zur Zeit, damit das Bild nicht flimmert. Die Namen kommen aus
   dem Block-Setting (data-marken), das Feld selbst ist 40 x 25 Punkte.
   Laeuft nur, solange der Screen wirklich steht. */
(function () {
  'use strict';

  var SPALTEN = 40;
  var ZEILEN = 25;
  /* Unser Punkt sitzt bei 51,25 % / 54 % — das ist Spalte 20, Zeile 13.
     In seiner Nachbarschaft leuchtet nichts auf, sonst verliert er sich. */
  var EIGEN_SPALTE = 20;
  var EIGEN_ZEILE = 13;
  var TAKT = 1700;
  var STANDZEIT = 2600;

  function still() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init() {
    if (still()) return;

    document.querySelectorAll('[data-fb-raster]').forEach(function (feld) {
      if (feld.__mlRaster) return;
      feld.__mlRaster = true;

      var marken = (feld.getAttribute('data-marken') || '')
        .split(',')
        .map(function (m) { return m.trim(); })
        .filter(function (m) { return m.length > 0; });
      if (!marken.length) return;

      var screen = feld.closest('.ml-fb__screen');
      var i = 0;

      function aufleuchten() {
        /* Der Screen liegt zwar im DOM, steht aber nur einmal wirklich da. */
        if (screen && !screen.classList.contains('is-aktiv')) return;

        var spalte, zeile;
        do {
          spalte = Math.floor(Math.random() * SPALTEN);
          zeile = Math.floor(Math.random() * ZEILEN);
        } while (Math.abs(spalte - EIGEN_SPALTE) < 5 && Math.abs(zeile - EIGEN_ZEILE) < 3);

        var el = document.createElement('span');
        el.className = 'ml-fb__raster-fremd';
        /* Rechts im Feld haengt der Name links am Punkt — sonst liefe er
           aus dem Bild. */
        if (spalte > SPALTEN * 0.62) el.className += ' ml-fb__raster-fremd--links';
        el.style.left = ((spalte + 0.5) * (100 / SPALTEN)) + '%';
        el.style.top = ((zeile + 0.5) * (100 / ZEILEN)) + '%';

        var punkt = document.createElement('i');
        var name = document.createElement('b');
        name.textContent = marken[i % marken.length];
        i += 1;
        el.appendChild(punkt);
        el.appendChild(name);
        feld.appendChild(el);

        window.setTimeout(function () {
          if (el.parentNode) el.parentNode.removeChild(el);
        }, STANDZEIT);
      }

      aufleuchten();
      window.setInterval(aufleuchten, TAKT);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
